var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficeAvatar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.9998,
    cy: 35.0001,
    r: 33.3333,
    fill: "#DFEBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1529 54.7867C26.3478 54.7905 24.5403 54.7942 22.7352 54.7867C19.966 54.7743 18.1186 52.9105 18.115 50.1308C18.1113 46.2792 18.115 42.4288 18.115 38.5784V37.9339H18.1138C17.5749 37.8955 17.1037 37.9141 16.6542 37.8249C14.9554 37.4866 13.7859 36.4828 13.3159 34.8097C12.8265 33.0661 13.2929 31.5269 14.6268 30.2938C17.1085 28.0024 19.6023 25.7259 22.0913 23.4432C25.3921 20.4144 28.693 17.3856 31.9939 14.3581C33.7797 12.721 36.2722 12.7111 38.0665 14.3494C43.8418 19.625 49.6147 24.903 55.3852 30.1848C56.7735 31.4563 57.2326 33.3424 56.585 35.0514C55.9289 36.7851 54.3353 37.8769 52.4251 37.8968C52.2704 37.898 52.1182 37.8968 51.8789 37.8968V38.5213C51.8789 42.3718 51.8814 46.2234 51.8789 50.0738C51.8765 52.9551 50.0436 54.7855 47.1656 54.7892C45.4113 54.7892 43.6569 54.7942 41.9038 54.7892H28.1529V54.7867Z",
    fill: "#307F92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0006 28.3106C37.5695 28.3106 40.782 26.3598 42.0659 29.6104C42.6895 31.1883 41.9625 34.4503 40.603 37.3896C40.7153 38.3712 40.7809 39.4851 40.7809 40.664C40.7809 44.6146 40.0628 47.8173 39.1746 47.8173C36.8259 47.8173 39.0135 39.3643 34.9995 39.3643C30.9856 39.3643 33.1198 47.8173 30.8244 47.8173C29.9374 47.8173 29.2193 44.6146 29.2193 40.664C29.2193 39.4851 29.2838 38.3712 29.3971 37.3896C28.0388 34.4503 27.3107 31.1883 27.9332 29.6104C29.2182 26.3598 32.4295 28.3106 34.9984 28.3106H35.0006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAvatar1);
export default __webpack_public_path__ + "static/media/Office-Avatar-1.2e6e8f45a1e40ec7fa90d76170623d02.svg";
export { ForwardRef as ReactComponent };